export class SearchAdministratorModel {
    public name : string='';
    public pageSize : number = 10;
    public pageNumber : number=1;
}